<mat-form-field class="me-2 rep-code-select">
  <mat-label>{{ field.label }}</mat-label>
  <input
    type="text"
    [placeholder]="field.label"
    matInput
    [matAutocomplete]="autoRepCode"
    [formControl]="repCodeControl"
    (blur)="onBlur($event)"
  />
  <mat-autocomplete
    #autoRepCode="matAutocomplete"
    (optionSelected)="changeSelection($event)"
  >
    @if (dropdownLoading) {
      <mat-option disabled class="dropdownLoadingSpinner">
        <mat-spinner diameter="48"></mat-spinner>
      </mat-option>
    }
    @if (!dropdownLoading && dropdownNoResults) {
      <mat-option disabled>No Results</mat-option>
    }
    @if (!dropdownLoading && !dropdownNoResults) {
      @for (opt of this.repUnits; track opt.repCode) {
        <mat-option
          matTooltip="({{ opt.repCode }})"
          matToolTipPosition="before"
          matTooltipShowDelay="750"
          value="{{ opt.repCode }}"
          class="custom-select-option"
        >
          {{ opt.repCode }}: {{ opt.repName || opt.name }}
        </mat-option>
      }
    }
  </mat-autocomplete>
  @if (showClearButton(field.varName)) {
    <button
      matSuffix
      mat-icon-button
      aria-label="Clear"
      color="warn"
      type="button"
      matTooltip="Clear Filter"
      (click)="resetFilter($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  @if (field.conditionalHint) {
    <mat-hint>{{ field.conditionalHint }}</mat-hint>
  }
</mat-form-field>
